import { PropsWithChildren, createContext, useSyncExternalStore } from 'react'

import { DxTradeAccountMetrics } from '@model/DxTrade.types'

import {
  DxtradeAccountMetricsMap,
  getMetricsStoreSnapshot,
  subscribeToMetricsStore,
  useDxtradeAccountWebSocket,
} from '../hooks/useDxtradeAccountWebSocket'

const DxtradeAccountMetricsContext = createContext<DxtradeAccountMetricsMap>({})

export const DxtradeAccountMetricsProvider = ({ children }: PropsWithChildren) => {
  const { metricsMap } = useDxtradeAccountWebSocket()

  return (
    <DxtradeAccountMetricsContext.Provider value={metricsMap}>
      {children}
    </DxtradeAccountMetricsContext.Provider>
  )
}

export const useDxtradeAccountMetricsWS = (
  accountKey: string
): DxTradeAccountMetrics | undefined => {
  return useSyncExternalStore(
    (listener) => subscribeToMetricsStore(accountKey, listener),
    () => getMetricsStoreSnapshot(accountKey),
    () => undefined
  )
}
